import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-place-banner', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 0,
    height: '163px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    borderBottom: '3px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
});

cssRule('.tb-subplace', {
    position: 'absolute',
    top: '166px',
    right: 0,
    bottom: 0,
    left: 0,
});

cssRule('.tb-tabs-banner-subplace', {
    position: 'absolute',
    top: '63px',
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

cssRule('.tb-stylish-settings', {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
});

cssRule('.tb-stylish-settings .tb-tabs-banner-subplace', {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
});

cssRule('.tb-place-information', {
    position: 'absolute',
    top: '58px',
    right: 0,
    bottom: 'auto',
    left: 0,
    height: '55px',
    marginLeft: '6px',
    marginRight: '18px',
    whiteSpace: 'nowrap',
    fontSize: '12px',
});

cssRule('.tb-place-information .tb-place-info', {
    marginRight: '12px',
    whiteSpace: 'normal',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-place-information .tb-place-info-item-label', {
    paddingRight: '6px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-place-type', {
    float: 'left',
    position: 'relative',
    paddingLeft: '12px',
    paddingRight: '12px',
    borderRight: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    marginRight: '12px',
});

cssRule('.tb-place-type-icon', {
    float: 'left',
    marginRight: '12px',
    minWidth: '60px',
    height: '60px',
    marginTop: '-2px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-flow', {
    backgroundImage: 'url(img/flow_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-project', {
    backgroundImage: 'url(img/project_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-workbook', {
    backgroundImage: 'url(img/workbook_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-datasource', {
    backgroundImage: 'url(img/data_source_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-group', {
    backgroundImage: 'url(img/group_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-icon.tb-place-type-icon-schedule', {
    backgroundImage: 'url(img/schedule_content_type.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-place-type-text', {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textTransform: 'uppercase',
});

cssRule('.tb-place-type-text-inline', {
    textTransform: 'uppercase',
});

cssRule('.tb-place-name-and-description', {
    marginLeft: '12px',
});

cssRule('.tb-place-name-line', {
    height: '32px',
    lineHeight: '32px',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-line', {
    marginTop: '5px',
    lineHeight: '19px',
});

cssRule('.tb-place-description-line-text', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-place-description-line-text-value', {
    display: 'inline-block',
    verticalAlign: 'top',
    marginLeft: '6px',
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
});

cssRule('.tb-place-description-flow-links', {
    display: 'inline-block',
    verticalAlign: 'top',
});

cssRule('.tb-place-description-line-owner', {
    maxWidth: '200px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-line-hits', {
    maxWidth: '80px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-line-favorites', {
    maxWidth: '80px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-line-separator', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    display: 'inline-block',
    verticalAlign: 'top',
    margin: '0 9px',
});

cssRule('.tb-place-favorite .tb-favorite-button', {
    display: 'inline-block',
    margin: '-12px 0 0 0',
    verticalAlign: 'middle',
});

cssRule('.tb-place-name', {
    float: 'left',
    maxWidth: '70%',
    height: '32px',
    lineHeight: '32px',
    fontSize: '28px',
    fontWeight: 'normal',
    color: applyColor(DesignTokens.color.font.default.secondary, '#4e4e4e'),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-name.tb-datasource-place-name', {
    maxWidth: '40%',
});

cssRule('.tb-place-name.tb-workbook-place-name', {
    maxWidth: '50%',
});

cssRule('.tb-place-description', {
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-text-holder', {
    display: 'inline-block',
    verticalAlign: 'top',
    maxWidth: '550px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

cssRule('.tb-place-description-full-width .tb-place-description-text-holder', {
    maxWidth: '750px',
});

cssRule('.tb-place-description-read-more', {
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: '12px',
});

cssRule('.tb-subplace-tabs', {
    position: 'absolute',
    top: 'auto',
    right: '18px',
    bottom: 0,
    left: '12px',
    height: '41px',
    whiteSpace: 'nowrap',
    overflow: 'initial',
});

cssRule('.tb-subplace-tabs.tb-small', {
    height: '31px',
});

cssRule('.tb-tabs-banner-title', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '41px',
    textDecoration: 'none',
    position: 'absolute',
    top: 'auto',
    right: '18px',
    bottom: 0,
    left: '18px',
});

cssRule('.tb-tabs-banner-title >.tb-label', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '41px',
    lineHeight: '41px',
    /* error: fontWeight: 'fongWeight', */
    fontSize: '18px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    borderBottom: '3px solid transparent',
    marginRight: '6px',
});

cssRule('.tb-tabs-banner-title >.tb-count', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '41px',
    lineHeight: '41px',
    fontSize: '12px',
    borderBottom: '3px solid transparent',
    paddingLeft: '6px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
    paddingRight: '6px',
});

cssRule('.tb-tabs-banner-title >.tb-label, .tb-tabs-banner-title >.tb-count', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-tabs-banner-title.tb-clickable', {
    cursor: 'pointer',
});

cssRule('.tb-tabs-banner-title-small', {
    display: 'inline-block',
    verticalAlign: 'top',
    height: '31px',
    textDecoration: 'none',
    position: 'absolute',
    top: 'auto',
    right: '18px',
    bottom: 0,
    left: '18px',
});

cssRule('.tb-tabs-banner-title-small >.tb-label', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '31px',
    lineHeight: '31px',
    /* error: fontWeight: 'fongWeight', */
    fontSize: '15px',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    borderBottom: '3px solid transparent',
    marginRight: '6px',
});

cssRule('.tb-tabs-banner-title-small >.tb-count', {
    display: 'inline-block',
    verticalAlign: 'baseline',
    height: '31px',
    lineHeight: '31px',
    fontSize: '12px',
    borderBottom: '3px solid transparent',
    paddingLeft: '6px',
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
    paddingRight: '6px',
});

cssRule('.tb-tabs-banner-title-small >.tb-label, .tb-tabs-banner-title-small >.tb-count', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-tabs-banner-title-small.tb-clickable', {
    cursor: 'pointer',
});

cssRule('.tb-details-header', {
    padding: '6px',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    height: '25px',
    borderBottom: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.subtle, '#E6E6E6'),
    position: 'relative',
});

cssRule('.tb-details-header-extract', {
    marginLeft: '18px',
    display: 'inline-block',
});

cssRule('.tb-details-header-title', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    fontWeight: 'bold',
    display: 'inline-block',
    height: '25px',
    lineHeight: '25px',
});

cssRule('.tb-details-header-main', {
    paddingLeft: '18px',
});

cssRule('.tb-details-header-sub', {
    padding: '6px',
    paddingRight: '18px',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 'auto',
    left: 'auto',
    textAlign: 'right',
    height: '25px',
    lineHeight: '25px',
});

cssRule('.tb-details-header-label', {
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
    fontWeight: 'bold',
    marginRight: '6px',
});

cssRule('.tb-more-actions .tb-inline-buttons', {
    textAlign: 'right',
});

